import {
  CircularLoader,
  ConvergeTooltip,
  PageTitle,
  StackLayout,
} from '../components';
import { PropsWithChildren, ReactNode } from 'react';

import { CustomPaletteColor } from '../../theme';
import { useTranslation } from 'react-i18next';

interface IProps extends PropsWithChildren {
  titleId: string;
  title: string;
  subtitleId?: string;
  subtitle?: string;
  icon?: ReactNode | boolean;
  color?: CustomPaletteColor;
  subtitleTooltip?: string;
  loading?: boolean;
}

export const LoadingPageLayout = ({
  titleId,
  title,
  subtitle,
  subtitleId,
  icon,
  children,
  color,
  subtitleTooltip,
  loading,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <StackLayout
      justifyContent="center"
      sx={{ flexGrow: 1 }}
      direction="column"
    >
      {icon === false
        ? null
        : icon ?? (
            <CircularLoader
              flexGrow={0}
              padding={1}
              color={loading ? 'info' : 'primary'}
              style={{ color: ' #28c0a7' }}
            />
          )}

      <PageTitle color={color ?? 'black'} sx={{ marginTop: 3 }}>
        {t(titleId, title)}
      </PageTitle>

      {subtitle &&
        subtitleId &&
        (subtitleTooltip ? (
          <ConvergeTooltip title={subtitleTooltip}>
            <PageTitle variant="h6">{t(subtitleId, subtitle)}</PageTitle>
          </ConvergeTooltip>
        ) : (
          <PageTitle variant="h6">{t(subtitleId, subtitle)}</PageTitle>
        ))}

      {children}
    </StackLayout>
  );
};
